export const NEW_ADMISSIONS_WORKSPACE_PATH = "/admissions/workspace"

const SLUG_PATTERN = /^[a-z0-9-]+$/
const SLUG_PLACEHOLDER = "{slug}"

type ResolveNewAdmissionsWorkspaceUrlParams = {
    slug?: string | null
    hostname?: string | null
    template?: string | null
}

const toHttpsUrl = (candidate: string): string | null => {
    try {
        const url = new URL(candidate)
        return url.protocol === "https:" ? url.toString() : null
    } catch {
        return null
    }
}

/**
 * The new admissions workspace lives on the `-next` sibling of the legacy host
 * (`demo.edular.com` -> `demo-next.edular.com`), unless an explicit template overrides it.
 */
export function resolveNewAdmissionsWorkspaceUrl({
    slug,
    hostname,
    template
}: ResolveNewAdmissionsWorkspaceUrlParams): string | null {
    if (template) {
        if (!slug || !SLUG_PATTERN.test(slug) || !template.includes(SLUG_PLACEHOLDER)) {
            return null
        }
        return toHttpsUrl(template.split(SLUG_PLACEHOLDER).join(slug))
    }

    if (!hostname) {
        return null
    }
    const labels = hostname.toLowerCase().split(".")
    const [firstLabel, ...rest] = labels
    const isIpAddress = labels.every((label) => /^\d+$/.test(label))
    const hasEmptyLabel = labels.some((label) => !label)
    if (!firstLabel || labels.length < 3 || isIpAddress || hasEmptyLabel || !SLUG_PATTERN.test(firstLabel)) {
        return null
    }
    return toHttpsUrl(`https://${firstLabel}-next.${rest.join(".")}${NEW_ADMISSIONS_WORKSPACE_PATH}`)
}

/** The sidebar link is shown only when the tenant flag is explicitly on (an older core omits it) and a URL resolves. */
export function getNewAdmissionsWorkspaceUrl({
    isNextPortalEnabled,
    ...params
}: ResolveNewAdmissionsWorkspaceUrlParams & {isNextPortalEnabled?: boolean | null}): string | null {
    if (isNextPortalEnabled !== true) {
        return null
    }
    return resolveNewAdmissionsWorkspaceUrl(params)
}
